// The profile picked after sign-in when one email holds several. Per tab and
// per session, so every new login asks again.
const KEY = 'sf_active_profile';

export const readActiveProfile = () => {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    return value?.token ? value : null;
  } catch {
    return null;
  }
};

export const writeActiveProfile = (profile) => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({
      token: profile.token,
      firstName: profile.firstName || '',
      fullName: profile.fullName || '',
    }));
  } catch { /* storage blocked: the picker just shows again */ }
};

export const clearActiveProfile = () => {
  try { sessionStorage.removeItem(KEY); } catch { /* nothing stored */ }
};

// From a /auth/token body: the profile to act as, or null when the user must pick.
export const chooseProfile = (data) => {
  const profiles = data?.profiles || [];
  if (data?.token && profiles.length <= 1) {
    return { token: data.token, firstName: data.firstName || '', fullName: data.fullName || '' };
  }
  const active = readActiveProfile();
  return (active && profiles.find((p) => p.token === active.token)) || null;
};
